module.exports = __webpack_public_path__ + "img/unlock.3e88c76e.svg";